// extracted by mini-css-extract-plugin
export var emailBlockLink = "_jd-0";